"use client";
import { SessionProvider } from "next-auth/react";

import React from "react";

const SessionWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <SessionProvider
      // Reduce aggressive refetching that can trigger errors in Safari
      refetchOnWindowFocus={false}
      // Refetch session every 5 minutes to keep it fresh
      refetchInterval={5 * 60}
      // Don't attempt refetch when offline (prevents errors)
      refetchWhenOffline={false}
    >
      {children}
    </SessionProvider>
  );
};

export default SessionWrapper;
